import './styles.module.css';
import SidebarComponent from './components/Sidebar';
import LogoComponent from './components/Logo';
import LogoTextComponent from './components/LogoText';
import DropdownItemComponent from './components/DropdownItem';
import InputItemComponent from './components/InputItem';
import ItemComponent from './components/Item';
import IconComponent from './components/Icon';
import TogglerComponent from './components/Toggler';

export const Sidebar = SidebarComponent;
export const Logo = LogoComponent;
export const LogoText = LogoTextComponent;
export const Item = ItemComponent;
export const Icon = IconComponent;
export const InputItem = InputItemComponent;
export const DropdownItem = DropdownItemComponent;
export const Toggler = TogglerComponent;
